import { render } from "./checkItem.vue?vue&type=template&id=c2ed3ce4&scoped=true&ts=true"
import script from "./checkItem.vue?vue&type=script&lang=ts"
export * from "./checkItem.vue?vue&type=script&lang=ts"

import "./checkItem.vue?vue&type=style&index=0&id=c2ed3ce4&scoped=true&lang=less"
import "./checkItem.vue?vue&type=style&index=1&id=c2ed3ce4&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ed3ce4"]])

export default __exports__